<script>
import { required, integer, minValue, maxValue } from 'vuelidate/lib/validators'
import { authComputed } from '@/state/helpers'
export default {
  name: 'pkf-form',
  props: {
    value: { type: Object, default: () => {} },
    submitLabel: { type: String, default: 'add to cart' },
    submitIcon: { type: String, default: 'bx bx-cart' }
  },

  data: vm => ({
    form: {
      reference: '',
      specs: {
        size: null,
        color: null,
        table_system: null,
        tube_length: 80
      },
      ...vm.value
    }
  }),

  methods: {
    reset () {
      this.form = {
        reference: '',
        specs: {
          size: 'small',
          color: 'blue',
          table_system: 'front',
          tube_length: 80
        }
      }
      this.$refs.wizard.reset()
    },
    onSaveHandler ($event, validate) {
      if (validate && typeof validate === 'function' && validate()) {
        this.$emit('complete', { ...this.form })
        this.reset()
      }
    },
    onCancel () {
      this.reset()
      this.$nextTick(() => {
        this.$emit('cancel')
      })
    }
  },
  computed: {
    ...authComputed,
    steps () {
      let steps = [
        {
          id: 'sr_form_basic_info',
          title: 'Basic Info',
          icon: 'bx bx-info-circle',
          component: () => import('../shared/reference'),
          active: this.userRole !== 'admin',
          validated: false
        },
        {
          id: 'sr_form_specs',
          title: 'Specifications',
          icon: 'bx bx-ruler',
          component: () => import('./specs'),
          active: false,
          validated: false
        },
        {
          id: 'shipping',
          title: 'Delivery Information',
          icon: 'bx bx-package',
          component: () => import('../shared/shipping'),
          active: false,
          validated: false
        }
      ]

      if (this.userRole === 'admin') {
        steps = [
          {
            id: 'select_customer',
            title: 'Customer',
            icon: 'bx bx-user',
            component: () => import('../shared/select-customer'),
            active: true,
            validated: false
          },
          ...steps
        ]
      }

      return steps
    }
  }
}
</script>
<template>
  <g-form-wizard :steps="steps" v-model="form" ref="wizard">
    <template
      v-slot:buttons="{
        isFirstStep,
        isLastStep,
        nextStep,
        previousStep,
        validateStep
      }"
    >
      <div
        class="d-flex justify-content-between align-items-center border-top pt-2"
      >
        <b-btn variant="link" class="mr-2" v-on:click="onCancel">
          Cancel
        </b-btn>

        <div class="d-flex justify-content-end w-100">
          <b-btn
            variant="link"
            class="mr-2 d-flex align-items-center"
            v-on:click="previousStep"
            :disabled="isFirstStep"
          >
            <i class="bx bx-left-arrow mr-2"></i>Back
          </b-btn>

          <b-btn
            variant="primary"
            class="btn-label mr-2"
            v-on:click="onSaveHandler($event, validateStep)"
            v-if="isLastStep"
          >
            <i class="label-icon" :class="[submitIcon]"></i>
            {{ $t(submitLabel) }}
          </b-btn>
          <b-btn
            variant="primary"
            class="mr-2 d-flex align-items-center"
            v-on:click="nextStep"
            v-else
          >
            Next<i class="bx bx-right-arrow ml-2"></i>
          </b-btn>
        </div>
      </div>
    </template>
  </g-form-wizard>
</template>
